export const isContactSelected = (contacts: { id: string; type: string }[], id: string, type: string) =>
  !!contacts.find((o) => o.id === id && o.type === type);
